import React, { useState } from 'react';
import StyledIcon from "../../../../components/common/StyledIcon";
import {generateCustomerReport} from "../actions/detailsPageActions";
import {connect} from "react-redux";

function Export ({generateCustomerReport, orderId, children, onRightClick}) {
    const [loadingLeft, setLoadingLeft] = useState(false);
    const [loadingRight, setLoadingRight] = useState(false);

    const handleLeftClick = async () => {
        setLoadingLeft(true);
        try {
            await generateCustomerReport(orderId);
        } finally {
            setLoadingLeft(false);
        }
    };

    const handleRightClick = async () => {
        setLoadingRight(true);
        try {
            if (onRightClick) {
                await onRightClick();
            }
        } finally {
            setLoadingRight(false);
        }
    };

    return (
        <div style={{padding: 16, fontWeight: 400, fontSize: 14, paddingTop: 0}}>
            <div style={{
                display: "flex",
                width: "100%"
            }}>
                {/* Lewa strona - Download */}
                <div
                    style={{
                        flex: 1,
                        textAlign: "center",
                        padding: "10px",
                        cursor: loadingLeft ? "wait" : "pointer"
                    }}
                    onClick={handleLeftClick}
                >
                    {loadingLeft ? (
                        <div style={{
                            display: "inline-block",
                            width: "32px",
                            height: "32px",
                            border: "2px solid #f3f3f3",
                            borderTop: "2px solid #3498db",
                            borderRadius: "50%",
                            animation: "spin 1s linear infinite"
                        }} />
                    ) : (
                        <span>Download data as .xlsx (zip)</span>
                    )}
                </div>

                {/* Pionowa kreska */}
                <div style={{
                    borderLeft: "1px solid #e0e0e0",
                    height: "auto",
                    margin: "0 10px"
                }} />

                {/* Prawa strona - Children */}
                <div
                    style={{
                        flex: 1,
                        textAlign: "center",
                        padding: "10px",
                        cursor: loadingRight ? "wait" : "pointer"
                    }}
                    onClick={handleRightClick}
                >
                    {loadingRight ? (
                        <div style={{
                            display: "inline-block",
                            width: "32px",
                            height: "32px",
                            border: "2px solid #f3f3f3",
                            borderTop: "2px solid #3498db",
                            borderRadius: "50%",
                            animation: "spin 1s linear infinite"
                        }} />
                    ) : (
                        <span>{children}</span>
                    )}
                </div>
            </div>

            {/* CSS animation dla spinnera */}
            <style>{`
                @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }
            `}</style>
        </div>
    )
}

function mapDispatchToProps() {
    return dispatch => ({
        generateCustomerReport: orderId => dispatch(generateCustomerReport(orderId))
    })
}

export default connect(null, mapDispatchToProps)(Export);